export const LANGUAGES = {
  DE: 'de_DE',
  EN: 'en_US',
};

export const DATE_FORMAT = {
  DE: 'DD.MM.YYYY',
};
